import { Container, Link } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";

const Footer = () => {
  return (
    <Box style={{ backgroundColor: "#2f3b4c" }}>
      <Container>
        <Box style={{ padding: "3% 0%" }}>
          <h1>Prantosh Bepari</h1>
          <p>
            Obviously I'm a Full Stack Web Developer. Experienced with all
            stages of the development cycle for dynamic web projects.
          </p>
          <Box>
            <Link
              rel="noreferrer"
              target="_blank"
              href="https://www.facebook.com/bepari.prantosh.5/"
            >
              <FacebookIcon sx={{ fontSize: 40, m: 1, color: "#fff" }} />
            </Link>
            <Link
              rel="noreferrer"
              target="_blank"
              href="https://www.linkedin.com/in/prantosh-bepari/"
            >
              <LinkedInIcon sx={{ fontSize: 40, m: 1, color: "#fff" }} />
            </Link>
            <Link
              rel="noreferrer"
              target="_blank"
              href="https://github.com/PrantoshBepari360"
            >
              <GitHubIcon sx={{ fontSize: 40, m: 1, color: "#fff" }} />
            </Link>
          </Box>
          <p style={{ paddingBottom: "10px" }}>
            © Copyright 2021 All Rights Reserved by Prantosh Bepari.
          </p>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
